export class GenInfo {
  callFrom: string;
  genInfoUno?: number;
  genInfoRefId?: number;
  meetingTypeUno?: number;
  meetingName?: string;
  subject?: string;
  momNo?: number;
  locationUno?: number;
  locationName?: string;
  meetingRoomUno?: number;
  meetingRoomName?: string;
  meetingDate?: Date;
  fMeetingDate?: string;
  startTime?: Date;
  fStartTime?: string;
  endTime?: Date;
  fEndTime?: string;
  userUno?: number;
  languageUno?: number;
  actionType: string;
  icon: string = 'GenInfo';
  type: string = 'GenInfo';
}

export class Attendees {
  attendeesUno?: number;
  userselUno?: number;
  userselName?: string;
  prNumber?: string;
  atdCatgorizeUno?: number;
  atdCatgorizeName?: string;
  roleUno?: number;
  roleName?: string;
  name?: string;
  company?: string;
  contact?: number;
  email?: string;
  userUno?: number;
  languageUno?: number;
  actionType: string;
  icon: string = 'Attendees';
  type: string = 'Attendees';
}
export class GenInfoAtd {
  delegateUserID: number;
  access: number;
  delegate: number;
  genInfoAtdUno: number=0;
  published?: number;
  meetingTypeUno?: number;
  meetingName?: string;
  subjectAtd?: string;
  approvalStatus?: string;
  momNoAtd?: any = '';
  locationUno?: number;
  others?: string;
  locationName?: string;
  meetingRoomUno?: number;
  meetingRoomName?: string;
  meetingDateAtd?: any;
  fMeetingDateAtd?: string;
  startTimeAtd?: any;
  fStartTimeAtd?: string;
  endTimeAtd?: any;
  fEndTimeAtd?: string;
  userUno?: number;
  actionType: string;
  callFrom: string;
  createrSign: string;
  attendeeSign: string;
  createDate: string;
  approverSign: string;
  reviewerSign: string;
  approvalDate: string;
  reviewDate: string;
  enteredBy?: number;
  approverId: number;
  reviewerId: number;
  type: string;
  pdfContent: string;
  initiatedBy:string;
  recordType: number;
  impCheck: boolean = false;
  delegateCheck: boolean = false;
  workFlowCondition1: boolean = false;
  workFlowCondition2: boolean = false;
  workFlowCondition3: boolean = false;
  workFlowCondition4: boolean = false;
  forImp: boolean = false;
  forDelay: boolean = false;
  forOwner: boolean = false;
  forReview: boolean = false;
  forApprove: boolean = false;
  startIndex: number=1;
  maxCount: number = 100;
  isApprover: boolean = false;
  isReviewer: boolean = false;
  forPublish: boolean = false;
  forPublishOnly: boolean = false;
  forAction: boolean = false;
  forReviewAssigned: boolean = false;
  forApprovalAssigned: boolean = false;
  varSortBy: string;
  forDelegate: boolean = false;
  forWithDelay: boolean = false;
  keyword: string = '';
  meetingStartDate: string;
  meetingEndDate: string;
  meetingStatus: number = null;
  meetingInitiatedBy: number=0;
  meetingAssignedTo: number=0;
  meetingPriority: number = 0;
  teamsMeetingId: string;
  teamsMeetingURL:string;
}




export class cmtObject {
  cmdId: number;
  genralInfoId: number;
  userId: number;
  cmdText: string;
  cmtUsers: string;
  cmtUserName: string;
  startIndex: number;
  maxCount: number;
  actionType: string;
  chatType: any;
}

export class alert {
  userUno: number;
  id: number;
  genInfoUno: number;
  isVisited: boolean;
  startIndex: number;
  maxCount: number;
  createdDate: Date;
  type?: string;
  description?: string;
  condition?: number;
}

export class MeetingAppoinments {
  apptId?: string;
  subject?: string;
  start?: string;
  end?: string;
  email?: string = '';
  location?: string;
  meetingDate?: string;
  UserName?: string;
  dayCount?: number;
}

export class OutlookFile {
  id?: string;
  fileName?: string;
  email?: string;
  dayCount?: number;
}

export class MeetingAttendee {
  email?: string = '';
  PRN?: string;
  name?: string;
  userUno?: number;
  active: true;
}


export class outlookAttendeeInsert {
  genInfoUno: number;
  userUno: number;
  attendeeJSONString?: string;
  fileJSONString?: string;
  agendaJSONString?: string;
  actionType: string;
}

export class AttendeesAtd {
  attendeesUnoAtd?: number=0;
  genInfoAtdUno?: number;
  userselUno?: number = 0;
  condition?: number = 0;
  userselName?: string;
  prNumberAtd?: string;
  role?: string;
  status?: string;
  nameAtd?: string;
  companyAtd?: string;
  contactAtd?: string;
  emailAtd?: string;
  userUno?: number;
  actionType: string;
  updateType: string;
  signImage: string;
  startIndex: number;
  maxCount: number;
  apologizedReason: string;
  designation: string;
  Picture: string;
  displayOrder: number;
  displayOrderJsonData: string;
  itemuno: any;
  genInfometuno: any;
  displayorder: any;
  teamsMeetingId: string;
  teamsMeetingURL:string;
}
export class FileAttachement {
  attachmentUno?: number;
  generalInfoId?: number;
  fileName?: string;
  contentType?: string;
  createByName?: string;
  createDate?: string;
  userId?: number;
  actionType: string;
  docType: number;
}
/*Agenda*/
export class AgendaDetails {
  agendaUno?: number=0;
  agendaParentUno?: number=0;
  genInfoAtdUno?: number;
  note?: string;
  priority: string= 'Low Priority';
  responsibility?: any;
  responsibilityName?: string;
  dueDate?: any;
  isActive?: number=1;
  userID?: number;
  startIndex?: number=0;
  maxCount?: number=10;
  userName: string;
  idVal: string;
  isDueDate: boolean = false;
  iReps: boolean=false;
  actionType: string;
  progress: number;
}
export class momDashboard {
  userUno?: number;
  startdt?: string;
  enddt?: string;
  actionType: string='';
  searchText: string='';
  noOfMyMeetings?: number;
  noOfMyAttendanceSheets?: number;
  noOfMyTasks?: string;
  noOfMyTBTSessions?: number;
  noOfDraftMeeting?: number;
  noOfNotPublishMeeting?: number;
  noOfPublishedMeeting?: number;
  noOfPartMeetings?: number;
  startIndex: number;;
  maxCount: number;
  divisionName: string;
  picture: string;
  userName: string;
  firstName: string;
  lastName: string;
  emailId: string;
  prNumber: string;
  lstMOMDashboard_MyMeetings: momDashboard_MyMeetings[] = [];
  lstMOMDashboard_PartofMeetings: momDashboard_PartofMeetings[] = [];
  
}

export class meetingAction {
  userUno?: number;
  flag?: string;
  forMe: boolean = false;
  forToday: boolean = false;
  forTommorrow: boolean = false;
  forOlder: boolean = false;
  forDelay: boolean = false;
  forComplete: boolean = false;
  lstMOMMeetingAction_DueToday: meetingAction_DueToday[] = [];
  lstMOMMeetingAction_DueTomorrow: meetingAction_DueTomorrow[] = [];
  lstMOMMeetingAction_LaterThisWeek: meetingAction_LaterThisWeek[] = [];
  lstMOMMeetingAction_DelayedTask: meetingAction_DelayedTask[] = [];
  lstMOMMeetingAction_CompleteTask: meetingAction_CompleteTask[] = [];

}

export class meetingAction_DueToday {
  agendaUno?: number;
  moMNoAtd?: string;
  note?: string;
  responsibility?: string;
  subjectAtd: string;
  dueDate?: string;
  isActive?: string;
  userName?: string;
  agendaParentUno?: number;
  genInfoUno?: number;
  userUno?: number;
  pageType?: number;
  startIndex?: number;
  maxCount?: number;
  progress?: number;
  location?: string;
  priority?: string;
}

export class meetingAction_DueTomorrow {
  agendaUno?: number;
  moMNoAtd?: string;
  note?: string;
  responsibility?: string;
  subjectAtd: string;
  dueDate?: string;
  isActive?: string;
  agendaParentUno?: number;
  genInfoUno?: number;
  userUno?: number;
  pageType?: number;
  location?: string;
  priority?: string;
}
export class meetingAction_CompleteTask {
  agendaUno?: number;
  moMNoAtd?: string;
  note?: string;
  responsibility?: string;
  subjectAtd: string;
  dueDate?: string;
  isActive?: string;
  agendaParentUno?: number;
  genInfoUno?: number;
  userUno?: number;
  pageType?: number;
  location?: string;
  priority?: string;
}
export class meetingAction_DelayedTask {
  agendaUno?: number;
  moMNoAtd?: string;
  note?: string;
  responsibility?: string;
  subjectAtd: string;
  dueDate?: string;
  isActive?: string;
  agendaParentUno?: number;
  genInfoUno?: number;
  userUno?: number;
  pageType?: number;
  location?: string;
  priority?: string;
}

export class meetingAction_LaterThisWeek {
  agendaUno?: number;
  moMNoAtd?: string;
  note?: string;
  responsibility?: string;
  subjectAtd: string;
  dueDate?: string;
  isActive?: string;
  agendaParentUno?: number;
  genInfoUno?: number;
  userUno?: number;
  pageType?: number;
  location?: string;
  priority?: string;
}
export class momDashboard_MyMeetings {
  genInfoAtdUno?: number;
  moMNoAtd?: string;
  subjectAtd?: string;
  meetingDate?: string;
  meetingRoom: string;
  startTime?: string;
  meetingName: string;
  endTime?: string;
  initiator?: string;
  published?: number;
  approvalStatus?: string;

}

export class momDashboard_PartofMeetings {
  genInfoAtdUno?: number;
  moMNoAtd?: string;
  subjectAtd?: string;
  meetingDate?: string;
  startTime?: string;
  endTime?: string;
  approvalStatus?: string;
  initiator?: string;
  meetingRoom: string;
  published?: number;
}
